import { useNotifications } from '@/composables/ui/useNotifications';

export function useContactMethods() {
  const { showNotification } = useNotifications();

  const makePhoneCall = (phoneNumber) => {
    try {
      const phoneLink = `tel:${phoneNumber.replace(/[^\d+]/g, '')}`;
      window.location.href = phoneLink;
      
      // Track the action
      window.dispatchEvent(new CustomEvent('contact:phone-clicked', {
        detail: { phone: phoneNumber, timestamp: Date.now() }
      }));
      
      showNotification({
        title: 'Calling...',
        message: `Dialing ${phoneNumber}`,
        type: 'info',
        duration: 3000
      });
      
      return true;
    } catch (error) {
      console.error('Error handling phone click:', error);
      
      // Fallback: copy phone number to clipboard
      navigator.clipboard.writeText(phoneNumber).then(() => {
        showNotification({
          title: 'Phone Number Copied',
          message: `${phoneNumber} copied to clipboard`,
          type: 'success',
          duration: 3000
        });
      });
      
      return false;
    }
  };

  const sendEmail = (emailAddress, subject = '') => {
    try {
      const emailLink = subject 
        ? `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}`
        : `mailto:${emailAddress}`;
      window.location.href = emailLink;
      
      // Track the action
      window.dispatchEvent(new CustomEvent('contact:email-clicked', {
        detail: { email: emailAddress, timestamp: Date.now() }
      }));
      
      showNotification({
        title: 'Email Client Opening...',
        message: `Opening email to ${emailAddress}`,
        type: 'info',
        duration: 3000
      });
      
      return true;
    } catch (error) {
      console.error('Error handling email click:', error);
      
      // Fallback: copy email to clipboard
      navigator.clipboard.writeText(emailAddress).then(() => {
        showNotification({
          title: 'Email Address Copied',
          message: `${emailAddress} copied to clipboard`,
          type: 'success',
          duration: 3000
        });
      });
      
      return false;
    }
  };

  return {
    makePhoneCall,
    sendEmail
  };
} 